import React, { useEffect, useState } from "react";
import { onfileSelected } from "../../../helpers/multimedia";

//Importar íconos de Material UI.
import { Add } from '@mui/icons-material/';

// BtnAddAnotherFIle: Componente que renderiza el botón para agregar nuevos archivos
// multimedia desde la vista previa.

const BtnAddAnotherFile = ({ filesSelected, setFilesSelected, setFileSelected, fileType, setOpenMessageFileSize }) => {
    const [inputAccept, setInputAccept] = useState("");

    // Función para agregar otro archivo a la lista para enviarse.
    const handleAddAnotherFile = (event) => {
        const selectedFile = event.target.files; // Extraer los datos del archivo seleccionado.
        onfileSelected(selectedFile, filesSelected, setFilesSelected, setOpenMessageFileSize); 
        setFileSelected(filesSelected[filesSelected.length - 1].name); // Establecer el nombre del archivo seleccionado en fileSelected
    };

    useEffect(() => {
        const onChangeInputAccept = () => { //Función para actualizar los formatos soportados por el input.
            if (fileType === "image") setInputAccept(".png, .jpg, .jpeg");
            if (fileType === "document") setInputAccept(".pdf, .word");
        };  
        onChangeInputAccept();
    }, [fileType]);

    return (
        <div className="container-img-preview__mini--btn--add" htmlFor="fileInput">
            <label className="btn-add__img--preview" htmlFor="fileInput">
                <span > <Add sx={{ cursor: "pointer" }} /></span>
                <input type="file" id="fileInput" onChange={handleAddAnotherFile} multiple accept={inputAccept}/>
            </label>
        </div>
    )
};

export default BtnAddAnotherFile;